export function readJson(key, fallbackValue) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return fallbackValue;
    }
    return JSON.parse(raw);
  } catch (_error) {
    return fallbackValue;
  }
}

export function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_error) {
    // no-op
  }
}

export function mergeStoredState(base, stored) {
  if (!stored || typeof stored !== 'object') {
    return base;
  }

  return {
    ...base,
    ...stored,
    id: base.id,
    implementation_date: base.implementation_date,
    name: base.name,
    title: base.title,
    role: base.role,
    element: base.element,
    race: base.race,
    affiliation: base.affiliation,
    s1: base.s1,
    s2: base.s2,
    s1_plus: base.s1_plus,
    s2_plus: base.s2_plus,
    accessory_name: base.accessory_name,
    accessory_effect: base.accessory_effect,
    unique_ability: base.unique_ability,
    unique_skill: base.unique_skill,
  };
}
